// Reveal-on-scroll for .reveal, .review-card, .featured-review, .partner-tile, etc.
// Adds .js-reveal-animation to <html> so CSS knows JS is alive and can apply
// the opacity:0 → opacity:1 reveal pattern. Without this class, all elements
// stay visible (graceful fallback).
(function() {
  document.documentElement.classList.add('js-reveal-animation');

  function reveal(el) {
    const delay = parseInt(el.getAttribute('data-delay')) || 0;
    setTimeout(() => el.classList.add('shown'), delay);
  }

  function setup() {
    const selectors = [
      '.reveal',
      '.review-card',
      '.featured-review',
      '.partner-tile',
      '.moment-tile',
      '.product-card',
      '.process-card',
      '.custom-feature',
      '.trusted-logo',
      '.pick-card',
    ];
    const els = document.querySelectorAll(selectors.join(','));
    if (!els.length) return;

    if ('IntersectionObserver' in window) {
      const io = new IntersectionObserver((entries) => {
        entries.forEach(e => {
          if (e.isIntersecting) {
            reveal(e.target);
            io.unobserve(e.target);
          }
        });
      }, { threshold: 0.05, rootMargin: '0px 0px -20px 0px' });

      els.forEach(el => {
        const rect = el.getBoundingClientRect();
        const vh = window.innerHeight || document.documentElement.clientHeight;
        if (rect.top < vh * 0.95) reveal(el);
        else io.observe(el);
      });
    } else {
      els.forEach(reveal);
    }

    // Failsafe — show everything after 1.5s no matter what
    setTimeout(() => els.forEach(reveal), 1500);
  }

  // Animated rating counters
  function animateCounter(el) {
    const target = parseFloat(el.getAttribute('data-target'));
    const duration = 1100;
    const t0 = performance.now();
    const tick = (t) => {
      const k = Math.min(1, (t - t0) / duration);
      const eased = 1 - Math.pow(1 - k, 3);
      el.textContent = (target * eased).toFixed(1);
      if (k < 1) requestAnimationFrame(tick);
    };
    requestAnimationFrame(tick);
  }
  function setupCounters() {
    const counters = document.querySelectorAll('[data-counter]');
    if (!counters.length) return;
    if ('IntersectionObserver' in window) {
      const cio = new IntersectionObserver((entries) => {
        entries.forEach(e => {
          if (e.isIntersecting) { animateCounter(e.target); cio.unobserve(e.target); }
        });
      }, { threshold: 0.3 });
      counters.forEach(el => {
        const rect = el.getBoundingClientRect();
        const vh = window.innerHeight;
        if (rect.top < vh * 0.95) animateCounter(el);
        else cio.observe(el);
      });
    } else {
      counters.forEach(animateCounter);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => { setup(); setupCounters(); });
  } else {
    setup();
    setupCounters();
  }
})();
